import { useMemo, useState } from "react";
import { Frame } from "@/components/diagrams/kit";
import { Input } from "@/components/ui/input";

const PRESETS = ["Line_3_Temp_Sensor", "L3.Capper.MicroStops", "Why did OEE drop on Line 3 last shift?", "PLANT1/LINE3/FILLER/F-301/SPEED_BPM"];

// Illustrative approximation: real tokenizers are model-specific.
function tokenize(text) {
  const pieces = text.match(/[A-Z]?[a-z]+|[A-Z]+(?![a-z])|\d+|\s+|[^\sA-Za-z\d]/g) || [];
  const out = [];
  pieces.forEach((p) => {
    if (/^\s+$/.test(p)) return;
    if (/^[A-Za-z]+$/.test(p) && p.length > 6) {
      for (let i = 0; i < p.length; i += 5) out.push(p.slice(i, i + 5));
    } else out.push(p);
  });
  return out;
}

const COLORS = ["bg-brand-primary/20", "bg-brand-accent/20", "bg-brand-data/20", "bg-brand-action/25"];

export default function TokenizerPlayground() {
  const [text, setText] = useState(PRESETS[0]);
  const tokens = useMemo(() => tokenize(text), [text]);
  const words = text.trim() ? text.trim().split(/\s+/).length : 0;
  return (
    <Frame title="Tokenizer playground" hint="Type a tag or question" testId="diagram-tokenizer">
      <Input data-testid="tokenizer-input" value={text} onChange={(e) => setText(e.target.value)} className="h-11 rounded-sm font-mono" aria-label="Text to tokenize" />
      <div className="mt-2 flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <button key={p} type="button" onClick={() => setText(p)} className="rounded-sm border border-border px-2 py-1 font-mono text-[11px] hover:bg-muted">{p}</button>
        ))}
      </div>
      <div data-testid="tokenizer-chips" className="mt-5 flex min-h-[48px] flex-wrap gap-1 border border-border bg-card p-3">
        {tokens.map((t, i) => <span key={i} className={`rounded-sm px-1.5 py-0.5 font-mono text-sm ${COLORS[i % 4]}`}>{t}</span>)}
      </div>
      <div className="mt-4 grid grid-cols-3 gap-px border border-border bg-border text-center">
        <div className="bg-card p-3"><div data-testid="tokenizer-count" className="font-heading text-2xl font-black">{tokens.length}</div><div className="text-xs text-muted-foreground">tokens (approx.)</div></div>
        <div className="bg-card p-3"><div className="font-heading text-2xl font-black">{words}</div><div className="text-xs text-muted-foreground">words</div></div>
        <div className="bg-card p-3"><div className="font-heading text-2xl font-black">{words ? (tokens.length / words).toFixed(1) : "0"}</div><div className="text-xs text-muted-foreground">tokens per word</div></div>
      </div>
      <p className="mt-3 text-xs text-muted-foreground">Illustrative split only — real token counts are model-dependent. Notice how industrial identifiers fragment into many tokens, which affects context fit, cost and tokens-per-minute limits.</p>
    </Frame>
  );
}
